"use client";

import * as React from "react";
import { SunMoon } from "lucide-react";
import { useTheme } from "next-themes";
import { Button } from "@/components/ui/button";

export function ThemeToggle() {
  const { setTheme, theme, resolvedTheme } = useTheme();
  const [mounted, setMounted] = React.useState(false);

  React.useEffect(() => {
    setMounted(true);
  }, []);

  if (!mounted) {
    return (
      <Button
        variant="ghost"
        size="sm"
        className="w-9 h-9 text-neutral-600 hover:bg-neutral-100 hover:text-brand-500 transition-all duration-200 dark:text-neutral-400 dark:hover:bg-neutral-800 dark:hover:text-neutral-200"
      >
        <SunMoon className="h-[1.2rem] w-[1.2rem]" />
        <span className="sr-only">Toggle theme</span>
      </Button>
    );
  }

  const toggleTheme = () => {
    setTheme(theme === "dark" ? "light" : "dark");
  };

  const isDark = resolvedTheme === "dark";

  return (
    <Button
      variant="ghost"
      size="sm"
      onClick={toggleTheme}
      className="w-9 h-9 text-neutral-600 hover:bg-neutral-100 hover:text-brand-500 transition-all duration-200 dark:text-neutral-400 dark:hover:bg-neutral-800 dark:hover:text-neutral-200"
      title={`Switch to ${isDark ? "light" : "dark"} mode`}
    >
      <SunMoon className="h-[1.2rem] w-[1.2rem] transition-transform duration-300 hover:rotate-12" />
      <span className="sr-only">Toggle theme</span>
    </Button>
  );
}
